import { ArrowForwardIcon, ArrowBackIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Text } from '@chakra-ui/react';
import React from 'react';

type PaginationProps = {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalRecords: number;
};

export const Pagination: React.FC<PaginationProps> = ({
  page,
  setPage,
  totalRecords,
}) => {
  const totalPages = Math.ceil(totalRecords / 100);

  return (
    <Flex gap={3} alignItems="center" mb={3}>
      <IconButton
        aria-label="previous"
        icon={<ArrowBackIcon />}
        onClick={() => setPage(Math.max(page - 1, 0))}
      />
      <Text size="lg">{page + 1}</Text>
      <IconButton
        aria-label="next"
        icon={<ArrowForwardIcon />}
        onClick={() => setPage(Math.min(page + 1, totalPages - 1))}
      />
    </Flex>
  );
};
